import { useUserStore } from "@slumbr/core";
import { useProfileSwitcherStore } from "@/stores/profile-switcher-store";

/** Who the API calls go out as: the account plus the persona (`X-Slumbr-Profile`). */
export function currentIdentity(): string {
  return `${useUserStore.getState().user?.id ?? ""}|${useProfileSwitcherStore.getState().activeProfileId ?? ""}`;
}

export function isSignedIn(): boolean {
  return Boolean(useUserStore.getState().user?.id);
}

/**
 * Calls `onChange` whenever the identity string read by `read` changes. Returns
 * the check to run on every store notification.
 */
export function createIdentityWatcher(read: () => string, onChange: () => void): () => void {
  let last = read();
  return () => {
    const next = read();
    if (next === last) return;
    last = next;
    onChange();
  };
}

/** Run `onChange` on sign-out, sign-in as someone else, or a persona switch. */
export function onIdentityChange(onChange: () => void): () => void {
  const check = createIdentityWatcher(currentIdentity, onChange);
  const offUser = useUserStore.subscribe(check);
  const offProfile = useProfileSwitcherStore.subscribe(check);
  return () => {
    offUser();
    offProfile();
  };
}
